import { createSvgComponent } from "../../icon/createSvgComponent";
import Success from "@core/icon/assets/success.svg";
export default createSvgComponent(Success);